export default {
  EMERGENCY_FUND_LOCATION_REPOSITORY: Symbol.for('EMERGENCY_FUND_LOCATION_REPOSITORY'),
  GET_EMERGENCY_FUND_LOCATION_QUERY: Symbol.for('GET_EMERGENCY_FUND_LOCATION_QUERY'),
  EMERGENCY_FUND_LOCATION_STATE_MANAGER: Symbol.for('EMERGENCY_FUND_LOCATION_STATE_MANAGER'),
};
